module.exports = __webpack_public_path__ + "media/images/cloud-mlx-emblem-c09bce00b3528d21f4f8bc8daf54021e.svg";